module.exports = __webpack_public_path__ + "img/logo_ua.02b1664c.png";